var map = {
	"./en": [
		"6pjB",
		1
	],
	"./en.ts": [
		"6pjB",
		1
	],
	"./it": [
		"7+UP",
		2
	],
	"./it.ts": [
		"7+UP",
		2
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "rDHf";
module.exports = webpackAsyncContext;